//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import productSuggestionBoundingBoxTemplate from '@legacy-components/intelligent-product-tagging/product-suggestion-bounding-box.html';

(function() {
  const curalate = angular.module('curalate');

  curalate.component('productSuggestionBoundingBox', {
    bindings: {
      boxId: '<',
      coordinates: '<',
      suggestionBoxClicked: '&',
    },
    template: productSuggestionBoundingBoxTemplate,
    controller: [
      function() {
        const self = this;

        self.onSuggestionBoxClicked = function($event) {
          self.clickPercentX = (($event.offsetX || $event.originalEvent.layerX) / $event.target.clientWidth) * 100;
          self.clickPercentY = (($event.offsetY || $event.originalEvent.layerY) / $event.target.clientHeight) * 100;

          self.hasBeenClicked = true;
          self.suggestionBoxClicked({
            boxId: self.boxId,
            event: $event,
          });
        };
      },
    ],
  });
})();
